import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllMenusQuery } from '@custom/schema';

export const useSiteMenusQuery = () => useStaticQuery(graphql(AllMenusQuery));
